const Filters = {
	// 小数点大于2位的四舍五入并保留2位小数点
	toFixed2: (val) => {
		var temp = String(val);
		if (temp.indexOf(".") != -1) {
			if (temp.split(".")[1].length > 2) {
				return val.toFixed(2);
			} else {
				return val;
			}
		} else {
			return val;
		}
	},
	//继续添加你需要的处理函数
}
let getDateT = date => {
	var str = "";
	if (date) {
		var arr = date.split("T");
		str = arr[0] + " " + arr[1].split(".")[0];
	}
	return str;
}
let getDateT2 = date => {
	var str = "";
	if (date) {
		var arr = date.split(" ");
		str = arr[0];
	}
	return str;
}
let fixed = date => {
	var str = date.toFixed(2)
	return str;
}
let getrank = date => {
	console.log(date)
	var str = ''
	if(date>-1){
		if(date == 0)
		str =  '中国煤炭行业协会'
		if(date == 1)
		str =  '央企/省份'
		if(date == 2)
		str =  '一级公司'
		if(date == 3)
		str =  '二级公司'
		if(date == 4)
		str =  '三级公司'
	}
	return str
}

export default {
	Filters,
	getDateT,
	fixed,
	getDateT2,
	getrank
}
